import { render, staticRenderFns } from "./COAAddAccountTransactionModal3.vue?vue&type=template&id=bb3bfd30&scoped=true&"
import script from "./COAAddAccountTransactionModal3.vue?vue&type=script&lang=js&"
export * from "./COAAddAccountTransactionModal3.vue?vue&type=script&lang=js&"
import style0 from "./COAAddAccountTransactionModal3.vue?vue&type=style&index=0&id=bb3bfd30&prod&lang=less&scoped=true&"
import style1 from "./COAAddAccountTransactionModal3.vue?vue&type=style&index=1&id=bb3bfd30&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3bfd30",
  null
  
)

export default component.exports